import { QueryClientProvider as TanstackQueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import React from 'react';

import { queryClient } from '@/shared/config/query-client.config';
import { useLocalization } from '@/shared/hooks/useLocalization';

interface QueryClientProviderProps {
  children: React.ReactNode;
}

/**
 * React Query Provider component
 * Wraps the application with QueryClient and provides React Query functionality
 */
export const QueryClientProvider: React.FC<QueryClientProviderProps> = ({ children }) => {
  const { isRTLDirect: isRTL } = useLocalization();

  return (
    <TanstackQueryClientProvider client={queryClient}>
      {children}
      {/* Only show devtools in development */}
      {process.env.NODE_ENV === 'development' && (
        <ReactQueryDevtools
          initialIsOpen={false}
          position="bottom"
          buttonPosition={isRTL ? 'bottom-left' : 'bottom-right'}
        />
      )}
    </TanstackQueryClientProvider>
  );
};

export { queryClient };
export default QueryClientProvider;
